import { motion } from 'framer-motion';
import { Users, Video, Pencil } from 'lucide-react';
import type { CalendarEvent } from '../../types/calendar';

interface MeetingCardProps {
  event: CalendarEvent;
  hasNote: boolean;
  index: number;
  onClick: () => void;
}

function hasZoomLink(event: CalendarEvent): boolean {
  const text = `${event.location ?? ''} ${event.notes ?? ''}`;
  return /zoom\.us/i.test(text);
}

export function MeetingCard({ event, hasNote, index, onClick }: MeetingCardProps) {
  const isZoom = hasZoomLink(event);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.15, delay: index * 0.03 }}
    >
      <div
        onClick={onClick}
        className={`surface-card p-4 cursor-pointer hover:border-border-default transition-colors flex gap-4 ${
          event.isCancelled ? 'opacity-40' : ''
        }`}
      >
        {/* Time column */}
        <div className="flex flex-col items-end w-12 shrink-0">
          <span className="text-caption font-mono text-text-muted">{event.startTime}</span>
          <span className="text-micro font-mono text-text-muted">{event.endTime}</span>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <h3 className={`text-title text-text-primary truncate ${event.isCancelled ? 'line-through' : ''}`}>
            {event.title}
          </h3>
          <div className="flex items-center gap-3 mt-1">
            {event.attendees.length > 0 && (
              <span className="flex items-center gap-1 text-caption text-text-muted">
                <Users size={12} />
                {event.attendees.length}
              </span>
            )}
            {isZoom && (
              <span className="flex items-center gap-1 text-caption text-text-muted">
                <Video size={12} />
                Zoom
              </span>
            )}
            {hasNote && (
              <span className="flex items-center gap-1 text-caption text-accent">
                <Pencil size={11} />
              </span>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
}
